import { render } from "./EditQuote.vue?vue&type=template&id=15ce73ea&ts=true"
import script from "./EditQuote.vue?vue&type=script&lang=ts"
export * from "./EditQuote.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__